import React from 'react';
export function EnergyChart() {
  return <div className="relative p-8 bg-white corner-accent mb-16" data-id="element-112">
      <div className="mb-6" data-id="element-113">
        <div className="flex justify-between items-start mb-4" data-id="element-114">
          <div data-id="element-115">
            <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-116">
              RENDIMIENTO DE OPTIMIZACIÓN
            </div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-117">PRONÓSTICO MERCADO</h3>
            <p className="text-sm text-gray-700" data-id="element-118">
              Comparación: CMG Real vs Programado vs Nuestra Proyección - 6 de
              Noviembre 2025
            </p>
          </div>
        </div>
      </div>

      <div className="w-full" data-id="element-119">
        <img src="https://pub-fde7a2e2a2904a56b4a80f8c1213c942.r2.dev/WhatsApp%20Image%202026-03-19%20at%209.28.06%20PM.jpeg" alt="Pronóstico de mercado - Comparación CMG Real vs Programado vs Nuestra Proyección" className="w-full h-auto" data-id="element-120" />
      </div>
    </div>;
}